import React from 'react';
import PropTypes from 'prop-types';
import Countdown from '../common/CountDown';
import ModalPreEmption from './ModalPreEmption';
import { t } from '../common/Translate';
import { Auth } from '../../config/configuration/react';

export const PreEmptOption = ({
  nrmRecordId,
  handleKeepCar,
  keepCarDecisionDate,
  recordId,
  isOpenPreEmption,
  setIsOpenPreEmption,
}) => {
  const roleId = Auth.roleId();

  return (
    <>
      <div className="d-flex align-items-center">
        <p className="text-primary font-weight-bold mr-3">{t('PreEmptionTimer')}</p>
        <p className="mr-3">
          <Countdown keepCarDecisionDate={keepCarDecisionDate} recordId={recordId} />
        </p>
      </div>
      {!Auth.roleViewerAccess() && (
        <>
          <div className="d-flex align-items-center">
            <p className="text-primary mr-3">{t('requestKeepCar')}</p>
          </div>
          <div className="d-flex align-items-center">
            <button type="button" className="btn btn-1 mr-2" onClick={() => setIsOpenPreEmption(!isOpenPreEmption)}>
              {t('yes')}
            </button>
            {(roleId === 3 || roleId === 5 || roleId === 6) && (
              <button type="button" className="btn btn-1" onClick={() => handleKeepCar(nrmRecordId, false, true)}>
                {t('no')}
              </button>
            )}
          </div>
          <ModalPreEmption
            closePreEmption={() => setIsOpenPreEmption(!isOpenPreEmption)}
            validatePreEmption={() => handleKeepCar(nrmRecordId, true, true)}
            toggle={() => setIsOpenPreEmption(!isOpenPreEmption)}
            isOpen={isOpenPreEmption}
          />
        </>
      )}
    </>
  );
};

PreEmptOption.propTypes = {
  nrmRecordId: PropTypes.string.isRequired,
  recordId: PropTypes.number.isRequired,
  handleKeepCar: PropTypes.func.isRequired,
  keepCarDecisionDate: PropTypes.oneOfType([PropTypes.object]).isRequired,
  isOpenPreEmption: PropTypes.bool.isRequired,
  setIsOpenPreEmption: PropTypes.func.isRequired,
};
